import Maintenance from "../../components/Maintenance"

const MaintenanceContainer = ({ headLess }) => (
  <Maintenance headLess={headLess} />
);

export default MaintenanceContainer;
